import React, { useState } from 'react';
import Navbar from '../components/Navbar';
import HeroSection from '../components/HeroSection';
import StatsSection from '../components/StatsSection';
import ProcessSection from '../components/ProcessSection';
import AboutSection from '../components/AboutSection';
import ServicesSlider from '../components/ServicesSlider';
import PricingSection from '../components/PricingSection';
import WhyChooseUsSection from '../components/WhyChooseUsSection';
import TestimonialsSlider from '../components/TestimonialsSlider';
import FAQSection from '../components/FAQSection';
import Footer from '../components/Footer';
import ContactModal from '../components/ContactModal';

const HomePage = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <div className="min-h-screen bg-navy-900">
      <Navbar onOpenModal={() => setIsModalOpen(true)} />
      <HeroSection onOpenModal={() => setIsModalOpen(true)} />
      <StatsSection />
      <ProcessSection />
      <AboutSection onOpenModal={() => setIsModalOpen(true)} />
      <ServicesSlider onOpenModal={() => setIsModalOpen(true)} />
      <PricingSection onOpenModal={() => setIsModalOpen(true)} />
      <WhyChooseUsSection />
      <TestimonialsSlider />
      <FAQSection />
      <Footer />
      <ContactModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </div>
  );
};

export default HomePage;
